import request from '@/utils/http';
// 公告列表接口
export const SupNoticeList = (params) => {
    return request({
        url: `/api-srm-web/bid/querySupplierNoticeManagerPageByFile`,
        method: 'post',
        data: params
    });
};
